/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Landing_Telegram_Mock_Draft_VerifiedInputs */

const tr_landing_telegram_mock_draft_verified = /** @type {(inputs: Landing_Telegram_Mock_Draft_VerifiedInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Alıcı ve tutar doğrulandı.`)
};

const en_landing_telegram_mock_draft_verified = /** @type {(inputs: Landing_Telegram_Mock_Draft_VerifiedInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Recipient and amount verified.`)
};

const de_landing_telegram_mock_draft_verified = /** @type {(inputs: Landing_Telegram_Mock_Draft_VerifiedInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Empfänger und Betrag geprüft.`)
};

const ru_landing_telegram_mock_draft_verified = /** @type {(inputs: Landing_Telegram_Mock_Draft_VerifiedInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Получатель и сумма проверены.`)
};

/**
* | output |
* | --- |
* | "Recipient and amount verified." |
*
* @param {Landing_Telegram_Mock_Draft_VerifiedInputs} inputs
* @param {{ locale?: "tr" | "en" | "de" | "ru" }} options
* @returns {LocalizedString}
*/
export const landing_telegram_mock_draft_verified = /** @type {((inputs?: Landing_Telegram_Mock_Draft_VerifiedInputs, options?: { locale?: "tr" | "en" | "de" | "ru" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Landing_Telegram_Mock_Draft_VerifiedInputs, { locale?: "tr" | "en" | "de" | "ru" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_landing_telegram_mock_draft_verified(inputs)
	if (locale === "de") return de_landing_telegram_mock_draft_verified(inputs)
	if (locale === "ru") return ru_landing_telegram_mock_draft_verified(inputs)
	return tr_landing_telegram_mock_draft_verified(inputs)
});